import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tryout-page-header-breadcrumb',
  templateUrl: './tryout-page-header-breadcrumb.component.html',
  styleUrls: ['./tryout-page-header-breadcrumb.component.css']
})
export class TryoutPageHeaderBreadcrumbComponent implements OnInit {
  public currentUrl = '';
  public routeParams;

  constructor(private activeRoute: ActivatedRoute, public router: Router) { }

  ngOnInit() {
    this.currentUrl = this.router.url;
    this.routeParams = this.activeRoute.snapshot.params;
  }

  isCurrentNewFeeFormPage() {
    const RP = this.routeParams;
    return this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1'
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step1/' + RP.feeId
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step2/' + RP.feeId
      || this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/fee/step3/' + RP.feeId;
  }

  isQuestionListingPage() {
    const RP = this.routeParams;
    return this.router.url === '/tryoutprogram/' + RP.name + '/' + RP.id + '/' + RP.status + '/question/' + RP.isRequired;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tryout-page-header-breadcrumb/tryout-page-header-breadcrumb.component.ts